<div mat-dialog-content>
    <mat-icon aria-hidden="false" aria-label="success">check_circle</mat-icon>
    <p>Registro con exíto, se te ha enviado un email para que puedas verificar tu cuenta.</p>
</div>
<mat-dialog-actions align="end">
    <button mat-button (click)="onGoToSignIn()">Cerrar</button>
</mat-dialog-actions>

